// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"83":"order-success","389":"404","899":"payment","962":"home"}[chunkId] || chunkId) + "." + {"83":"ec0d693c","389":"13eda01e","626":"25ef8130","899":"34910d46","962":"54b23334"}[chunkId] + ".css";
};